import http from 'plugins/axios';

export default {
  getSwitchList() {
    return http.get({
      url: '/la/admin/switch/list'
    });
  },
  updateSwitchStatus({ coinType, switchType, status }) {
    return http.post({
      url: `/la/admin/switch/update/${coinType}/${switchType}/${status}`
    });
  },
  updateBatchWithdrawSize({ coinType, size }) {
    return http.post({
      url: '/la/admin/switch/update/batchWithdrawSize',
      data: {
        coinType,
        size
      },
      dataType: 'form'
    });
  },
  updateGasPrice({ coinType, price }) {
    return http.post({
      url: '/la/admin/switch/update/gasPrice',
      data: {
        coinType,
        price
      },
      dataType: 'form'
    });
  },
  updateToColdGasPrice({ coinType, price }) {
    return http.post({
      url: '/la/admin/switch/update/toColdGasPrice',
      data: {
        coinType,
        price
      },
      dataType: 'form'
    });
  },
  getBatchSwitchList() {
    return http.get({
      url: '/la/admin/switch/batch/list'
    });
  },
  updateBatchSwitchStatus({ name, switchType, status }) {
    return http.post({
      url: `/la/admin/switch/batch/update/${name}/${switchType}/${status}`
    });
  },
  updateJobBatchSize({ name, size }) {
    return http.post({
      url: `/la/admin/switch/batch/update/batchSize/${name}/${size}`
    });
  }
};
